import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

const measuredFields = [
  { key: 'boilerMakeup', label: 'FM-01: Boiler Makeup' },
  { key: 'preheatWater', label: 'FM-02: Pre-Heated Water' },
  { key: 'coolingWater', label: 'FM-03: Blowdown Cooling Water' },
  { key: 'steamProduction', label: 'FM-04: Steam To Plant' },
  { key: 'boilerGas', label: 'FM-05: Boiler Gas' },
  { key: 'inletTemp', label: 'TI-01: Soft Water Temp' },
  { key: 'outletTemp', label: 'TI-02: Pre-Heated Water Temp' },
  { key: 'boilerAmps', label: 'BA-01: Boiler Amps' },
];

const calculatedFields = [
  { key: 'boilerInput', label: 'BI-01: Boiler Input' },
  { key: 'steamLoad', label: 'SL-01: Steam Load' },
  { key: 'energyRecovery', label: 'ECONO-01: Energy Recovery' },
  { key: 'totalEnergy', label: 'TE-01: Total Energy to Process' },
  { key: 'heatLosses', label: 'HL:-01: Heat Losses' },
  { key: 'boilerEfficiency', label: 'BE-01: Boiler Efficiency' },
  { key: 'systemEfficiency', label: 'SE-01: System Efficiency' },
  
];

const BoilerPanel = ({ checked, onChange, disabledFields = [], disabled = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 4,
        p: 2,
        border: '1px solid #ccc',
        borderRadius: 1,
        backgroundColor: 'rgba(255,255,255,0.4)',
        minWidth: 360,
      }}
    >
      <Box>
        <Typography variant="subtitle2" fontWeight={700} mb={1}>
          Measured Parameters
        </Typography>
        {measuredFields.map(({ key, label }) => (
          <Box key={key} display="flex" alignItems="center">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={!!checked?.[key]}
                  disabled={disabled || disabledFields.includes(key)}
                  onChange={e => onChange?.(key, e.target.checked)}
                  sx={{ '&.Mui-checked': { color: 'rgb(0,177,168)' } }}
                />
              }
              label={<Typography variant="body2">{label}</Typography>}
            />
          </Box>
        ))}
      </Box>

      <Box>
        <Typography variant="subtitle2" fontWeight={700} mb={1}>
          Calculated Parameters
        </Typography>
        {calculatedFields.map(({ key, label }) => (
          <Box key={key} display="flex" alignItems="center">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={!!checked?.[key]}
                  disabled={disabled || disabledFields.includes(key)}
                  onChange={e => onChange?.(key, e.target.checked)}
                  sx={{ '&.Mui-checked': { color: 'rgb(0,177,168)' } }}
                />
              }
              label={<Typography variant="body2">{label}</Typography>}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BoilerPanel;
